import { render } from "./AI2.vue?vue&type=template&id=09b44eb8&scoped=true"
import script from "./AI2.vue?vue&type=script&lang=js"
export * from "./AI2.vue?vue&type=script&lang=js"

import "./AI2.vue?vue&type=style&index=0&id=09b44eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b44eb8"]])

export default __exports__